<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gO1js3/tc-custom/9781649795557.jpg?1705540719146" alt="This image is the cover for the book Bernie and Babs vs the Virus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bernie and Babs vs the Virus
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'>Journey with Bernie and Babs on a self-healing visualization. Bang those baddies on the head and send them to waste disposal.</p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><br/></p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'>Bernie and Babs take on the virus with magic hammers and some serious hi-tech know-how. Adventure awaits in this charming and useful book that gives you a visual that can be used to imagine your own healing. See you in the cranial control center for bug and bot deployment. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Grandma Ness
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'>I healed myself the way I show in the book (Lupus). I taught my children and they do the same. My grandchildren are learning now.&nbsp;</p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><br></p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'>Twenty-two years ago I had the idea to write the words, did the first rendition of Bernie and Babs, and put down a storyboard. Nine months ago while transferring my art cabinet to the new studio (I am a painter by trade) that work fell out in the yard. My new adopted dog grabbed it and brought it inside and put it on my lap. Since then every time I let it fall aside, a sketch or painting falls off a table or wall to the ground. I have no credentials to validate my knowledge or the vision of this book. I do have the unwavering knowing that it will help heal millions if not billions. Our minds are miracles we have yet to tap to the fullest. This book is a step toward that.&nbsp;</p><p style="margin: 0cm 0cm 0.0001pt; font-size: 15px; font-family: Calibri, sans-serif; text-align: right; background: white;"><span style='font-size:16px;font-family:"Arial",sans-serif;color:black;'>– Grandma Ness</span></p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><br></p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><br></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cddb51c2